module.exports = __webpack_public_path__ + "img/bitcoin-btc-gold.5a525e07.svg";